<template>
  <div>
    <BreadcrumbBanner
      :pageTitle="$t('Search')"
      :links="[
        { name: $t('Home'), url: '/' },
        { name: $t('Search') }
      ]"
    />
    <!--Casino Demo-->
    <div class="casino-demo pb-60 pb-60" v-if="games.length > 0">
      <div class="container-fluid">
        <div class="all-games-wrapper">
          <div class="section-wrapper">
            <h4 class="left-title live-text d-flex align-items-center">
              <span class="icon"
                ><img src="@/assets/img/favarites/love.png" alt="badge"
              /></span>
              {{ $t("Search Result") }} <span class="text-base text">{{ games.length }}</span>
            </h4>
          </div>
          <div class="row g-3">
            <div v-for="game in games" :key="game.id" class="col-xxl-3 col-xl-4 col-md-4 col-sm-6">
              <GameCard :game="game" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="recent-view" v-else>
      <div class="container-fluid">
        <div class="d-flex flex-column flex-nowrap align-items-center p-4 m-4">
          <h2>{{ $t('No result') }}</h2>
          <p>{{ $t('No search result found, try another keyword') }}</p>
        </div>
      </div>
    </div>
    <!--Casino Demo-->
  </div>
</template>

<script>

import BreadcrumbBanner from "@/components/partials/Breadcumnd.vue";
import { useSearchStore } from '@/store/search'
import { mapActions, mapState } from "pinia";
import GameCard from "@/components/partials/GameCard.vue";
import helpers from "@/helpers";

export default {
  name: "SearchPage",
  components: {
    BreadcrumbBanner,
    GameCard,
  },
  computed: {
    ...mapState(useSearchStore, ['games'])
  },
  methods: {
    ...mapActions(useSearchStore, ["fetchSearchData"]),
    async fetchSearch(searchQuery) {
      if (searchQuery == "") return;

      await this.fetchSearchData(searchQuery).then((response) => {
        if (!response.data) {
          helpers.showToast(this.$t("Failed to search, try another name"), this.$t("Search Failed"), "error");
        }
      });
    },
  },
  async mounted() {
    if(this.$route.query.query) {
      let query = decodeURIComponent(this.$route.query.query);
      this.fetchSearch(query);
    }
  },
};
</script>
